export default __webpack_public_path__ + "static/media/arrow.2984070f.gif";